var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content album-detail-page" },
    [
      _c(
        "el-form",
        {
          ref: "updateAlbumRequest",
          staticClass: "demo-ruleForm album-form",
          attrs: {
            model: _vm.updateAlbumRequest,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c("div", { staticClass: "page-header-card" }, [
            _c("div", [
              _c("h2", { staticClass: "page-title" }, [
                _vm._v("Chi tiết album"),
              ]),
              _c("p", { staticClass: "page-description" }, [
                _vm._v(
                  "\n          Chỉnh sửa thông tin album, thêm ảnh mới hoặc duyệt ảnh đã tải lên.\n        "
                ),
              ]),
            ]),
            _c("div", { staticClass: "header-badges" }, [
              _c("div", { staticClass: "summary-badge" }, [
                _c("span", { staticClass: "summary-badge__label" }, [
                  _vm._v("Đối tượng"),
                ]),
                _c("strong", { staticClass: "summary-badge__value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.updateAlbumRequest.selectObject === "student"
                          ? "Lớp"
                          : "Trường"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "summary-badge" }, [
                _c("span", { staticClass: "summary-badge__label" }, [
                  _vm._v("Ảnh đã duyệt"),
                ]),
                _c("strong", { staticClass: "summary-badge__value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.updateAlbumRequest.pictureApprovedNumber || 0
                      ) +
                      "/" +
                      _vm._s(_vm.updateAlbumRequest.pictureNumber || 0) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "form-shell" }, [
            _c(
              "section",
              { staticClass: "section-card" },
              [
                _c("div", { staticClass: "section-heading" }, [
                  _c("div", [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v("Thông tin album"),
                    ]),
                    _c("p", { staticClass: "section-description" }, [
                      _vm._v("Chỉnh sửa tên, đối tượng và mô tả album."),
                    ]),
                  ]),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { xs: 24, md: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "field-item",
                            attrs: { label: "Tên album", prop: "albumName" },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập tiêu đề..." },
                              model: {
                                value: _vm.updateAlbumRequest.albumName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.updateAlbumRequest,
                                    "albumName",
                                    $$v
                                  )
                                },
                                expression: "updateAlbumRequest.albumName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, md: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "field-item",
                            attrs: { label: "Đối tượng" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "full-width",
                                attrs: { placeholder: "Chọn đối tượng" },
                                on: { change: _vm.handleChangeObject },
                                model: {
                                  value: _vm.updateAlbumRequest.selectObject,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updateAlbumRequest,
                                      "selectObject",
                                      $$v
                                    )
                                  },
                                  expression: "updateAlbumRequest.selectObject",
                                },
                              },
                              _vm._l(_vm.listSelectObject, function (item) {
                                return _c(
                                  "el-option",
                                  {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.label))])]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "description-item",
                    attrs: { label: "Mô tả album", prop: "desc" },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "Nhập nội dung...",
                        rows: 3,
                        type: "textarea",
                      },
                      model: {
                        value: _vm.updateAlbumRequest.albumDescription,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.updateAlbumRequest,
                            "albumDescription",
                            $$v
                          )
                        },
                        expression: "updateAlbumRequest.albumDescription",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.updateAlbumRequest.selectObject === "student"
              ? _c("section", { staticClass: "section-card" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "section-heading section-heading--space-between",
                    },
                    [
                      _c("div", [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("Phạm vi học sinh"),
                        ]),
                        _c("p", { staticClass: "section-description" }, [
                          _vm._v(
                            "Chọn học sinh áp dụng cho album theo từng lớp."
                          ),
                        ]),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "student-select-button",
                          attrs: { type: "primary", icon: "el-icon-user" },
                          on: { click: _vm.clickSelectStudent },
                        },
                        [
                          _vm._v(
                            "\n            Chọn học sinh trong lớp\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "student-list-panel" }, [
                    _c("div", { staticClass: "student-list-panel__header" }, [
                      _c("div", [
                        _c("h4", { staticClass: "student-list-title" }, [
                          _vm._v("Danh sách học sinh"),
                        ]),
                        _c("span", { staticClass: "student-list-subtitle" }, [
                          _vm._v(
                            "\n                Đã chọn " +
                              _vm._s(
                                _vm.updateAlbumRequest.kids
                                  ? _vm.updateAlbumRequest.kids.length
                                  : 0
                              ) +
                              " học sinh\n              "
                          ),
                        ]),
                      ]),
                    ]),
                    !_vm.updateAlbumRequest.kids ||
                    _vm.updateAlbumRequest.kids.length === 0
                      ? _c("div", { staticClass: "student-empty-state" }, [
                          _c("i", {
                            staticClass:
                              "el-icon-user-solid student-empty-state__icon",
                          }),
                          _c(
                            "div",
                            { staticClass: "student-empty-state__title" },
                            [_vm._v("Chưa có học sinh nào được chọn")]
                          ),
                          _c(
                            "div",
                            { staticClass: "student-empty-state__desc" },
                            [
                              _vm._v("\n              Nhấn "),
                              _c("strong", [_vm._v("Chọn học sinh trong lớp")]),
                              _vm._v(
                                " để thêm học sinh vào album này.\n            "
                              ),
                            ]
                          ),
                        ])
                      : _c(
                          "div",
                          { staticClass: "answer_apply" },
                          _vm._l(
                            _vm.updateAlbumRequest.kids,
                            function (kid, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "kid-row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "kid-row__icon-wrap" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-circle-check kid-row__icon",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "kid-row__content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "kid-row__name" },
                                        [_vm._v(_vm._s(kid.kidsName))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "kid-row__meta" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.parseKidStatusVietnamese(
                                                  kid.statusKids
                                                )
                                              ) +
                                              " • " +
                                              _vm._s(kid.className) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                  ]),
                ])
              : _vm._e(),
            _c(
              "section",
              { staticClass: "section-card" },
              [
                _c("div", { staticClass: "section-heading" }, [
                  _c("div", [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v("Thêm ảnh mới"),
                    ]),
                    _c("p", { staticClass: "section-description" }, [
                      _vm._v("Tải ảnh lên để bổ sung vào album."),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "upload-toolbar" }, [
                  _c("div", { staticClass: "upload-left" }, [
                    _c("div", { staticClass: "upload-note-card" }, [
                      _c("span", { staticClass: "upload-note-card__label" }, [
                        _vm._v("Đang chờ tải lên"),
                      ]),
                      _c("strong", { staticClass: "upload-note-card__value" }, [
                        _vm._v(_vm._s(_vm.fileList.length) + " ảnh"),
                      ]),
                    ]),
                    _vm.fileList && _vm.fileList.length > 0
                      ? _c("div", { staticClass: "selected-summary" }, [
                          _c("img", {
                            staticClass: "selected-summary__thumb",
                            attrs: { src: _vm.fileList[0].url, alt: "ảnh" },
                          }),
                          _c("div", { staticClass: "selected-summary__text" }, [
                            _vm._v(
                              _vm._s(_vm.fileList.length) + " ảnh đã chọn"
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "selected-summary" }, [
                          _c(
                            "div",
                            { staticClass: "selected-summary__empty" },
                            [_vm._v("Chưa có ảnh mới")]
                          ),
                        ]),
                  ]),
                  _c("div", { staticClass: "upload-right" }, [
                    _vm.showProgress
                      ? _c(
                          "div",
                          { staticClass: "progress-wrap" },
                          [
                            _c("el-progress", {
                              staticClass: "upload-progress",
                              attrs: {
                                percentage: _vm.percentage,
                                color: _vm.colors,
                              },
                            }),
                            _c("div", { staticClass: "progress-label" }, [
                              _vm._v(_vm._s(_vm.percentage) + "%"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
                _c("el-upload", {
                  ref: "upload",
                  staticClass: "upload-area",
                  attrs: {
                    action: "#",
                    "list-type": "picture-card",
                    "auto-upload": false,
                    "file-list": _vm.fileList,
                    "on-change": _vm.handleChangePicture,
                    "on-remove": _vm.handleRemove,
                    multiple: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "upload-trigger" }, [
                            _c("i", {
                              staticClass: "el-icon-plus upload-trigger__icon",
                            }),
                            _c(
                              "span",
                              { staticClass: "upload-trigger__text" },
                              [_vm._v("Thêm ảnh")]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "file",
                      fn: function ({ file }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "container_image_upload" },
                            [
                              _c("TagFlag", { attrs: { title: "Mới" } }),
                              _c("img", {
                                staticClass: "el-upload-list__item-thumbnail",
                                attrs: { src: file.url, alt: "" },
                              }),
                              _c(
                                "span",
                                { staticClass: "el-upload-list__item-actions" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-preview",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePictureCardPreview(
                                            file
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in",
                                      }),
                                    ]
                                  ),
                                  !_vm.disabled
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-delete",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRemove(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      width: "30%",
                      visible: _vm.dialogVisible,
                      top: "50px",
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialogVisible = $event
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: _vm.dialogImageUrl,
                        alt: "",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c("section", { staticClass: "section-card" }, [
              _c("div", { staticClass: "section-heading" }, [
                _c("div", [
                  _c("h3", { staticClass: "section-title" }, [
                    _vm._v(
                      "\n              Danh sách ảnh album\n              "
                    ),
                    _vm.updateAlbumRequest.albumName
                      ? _c("span", { staticClass: "album-name-inline" }, [
                          _vm._v(
                            "\n                — " +
                              _vm._s(_vm.updateAlbumRequest.albumName) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c("p", { staticClass: "section-description" }, [
                    _vm._v("Xem, duyệt hoặc xóa ảnh đã có trong album."),
                  ]),
                ]),
              ]),
              Array.isArray(_vm.updateAlbumRequest.alistPictureList) &&
              _vm.updateAlbumRequest.alistPictureList.length
                ? _c(
                    "div",
                    { staticClass: "picture-grid" },
                    _vm._l(
                      _vm.updateAlbumRequest.alistPictureList,
                      function (listPicture, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "picture-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "picture-card__img-wrap" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Xem ảnh",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-image", {
                                      staticClass:
                                        "picture-card__img el-image-opacity",
                                      attrs: {
                                        src: listPicture.urlPictureShow,
                                        fit: "cover",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleShowDetailPicture(
                                            index,
                                            listPicture
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "picture-card__badge",
                                    class: listPicture.isApproved
                                      ? "badge--approved"
                                      : "badge--pending",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          listPicture.isApproved
                                            ? "Đã duyệt"
                                            : "Chờ duyệt"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm.checkPermission(["studentQuality_ablum_update"])
                              ? _c(
                                  "div",
                                  { staticClass: "picture-card__actions" },
                                  [
                                    !listPicture.isApproved
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "picture-card__btn",
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                              icon: "el-icon-check",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateApprovePicture(
                                                  listPicture.id,
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Duyệt")]
                                        )
                                      : _c(
                                          "el-button",
                                          {
                                            staticClass:
                                              "picture-card__btn picture-card__btn--approved",
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                              icon: "el-icon-check",
                                              disabled: "",
                                            },
                                          },
                                          [_vm._v("Đã duyệt")]
                                        ),
                                    _c("el-button", {
                                      staticClass: "picture-card__btn",
                                      attrs: {
                                        type: "danger",
                                        size: "mini",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deletePicture(
                                            listPicture.id
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "pictures-empty-state" }, [
                    _c("i", {
                      staticClass:
                        "el-icon-picture-outline pictures-empty-state__icon",
                    }),
                    _c("div", { staticClass: "pictures-empty-state__title" }, [
                      _vm._v("Album chưa có ảnh nào"),
                    ]),
                    _c("div", { staticClass: "pictures-empty-state__desc" }, [
                      _vm._v(
                        'Hãy tải ảnh lên ở phần "Thêm ảnh mới" phía trên.'
                      ),
                    ]),
                  ]),
            ]),
          ]),
          _c("div", { staticClass: "actions-footer" }, [
            _c("div", { staticClass: "actions-footer__left" }, [
              _c("span", { staticClass: "meta-author" }, [
                _c("strong", [_vm._v("Người đăng:")]),
                _vm._v(" " + _vm._s(_vm.updateAlbumRequest.createdBy)),
              ]),
              _c("span", { staticClass: "meta-divider" }, [_vm._v("|")]),
              _c("span", { staticClass: "meta-info" }, [
                _vm._v(
                  _vm._s(_vm.updateAlbumRequest.pictureApprovedNumber) +
                    "/" +
                    _vm._s(_vm.updateAlbumRequest.pictureNumber) +
                    " ảnh"
                ),
              ]),
              _c("span", { staticClass: "meta-divider" }, [_vm._v("|")]),
              _c("span", { staticClass: "meta-info" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatDate")(_vm.updateAlbumRequest.createdDate)
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "actions-footer__right" },
              [
                _vm.checkPermission(["studentQuality_ablum_update"])
                  ? _c(
                      "el-button",
                      {
                        staticClass: "button-over",
                        attrs: {
                          type: "success",
                          icon: "el-icon-circle-check",
                          loading: _vm.loadingButton,
                          disabled:
                            _vm.loadingButton || _vm.compressingCount > 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.submitUpload("updateAlbumRequest")
                          },
                        },
                      },
                      [_vm._v("\n          Lưu thay đổi\n        ")]
                    )
                  : _vm._e(),
                _vm.checkPermission(["studentQuality_ablum_update"])
                  ? _c(
                      "el-button",
                      {
                        staticClass: "button-over",
                        attrs: { type: "warning", icon: "el-icon-finished" },
                        on: {
                          click: function ($event) {
                            return _vm.updateAllApprovePicture(
                              _vm.updateAlbumRequest.id
                            )
                          },
                        },
                      },
                      [_vm._v("\n          Duyệt tất cả\n        ")]
                    )
                  : _vm._e(),
                _c(
                  "router-link",
                  {
                    staticClass: "cancel-link",
                    attrs: { to: "/student-quality/album" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "button-over",
                        attrs: { type: "danger", icon: "el-icon-back" },
                        on: {
                          click: function ($event) {
                            return _vm.createEmployeeDialog()
                          },
                        },
                      },
                      [_vm._v("\n            Quay lại\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "album-preview-dialog",
          attrs: { width: "55%", visible: _vm.dialogVisiblePic, top: "25px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisiblePic = $event
            },
          },
        },
        [
          _c("div", { staticClass: "image-container" }, [
            _c("img", {
              staticClass: "centered-image",
              attrs: { src: _vm.selectedImg, alt: "Ảnh album" },
            }),
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-d-arrow-left",
                      disabled: _vm.indexSrc <= 0,
                    },
                    on: { click: _vm.backPage },
                  },
                  [_vm._v("Trước")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success" },
                    on: { click: _vm.setUpAvatarAlbum },
                  },
                  [_vm._v("Đặt làm ảnh đại diện")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: _vm.indexSrc >= _vm.alistPictureList.length - 1,
                    },
                    on: { click: _vm.nextPage },
                  },
                  [
                    _vm._v("Sau "),
                    _c("i", { staticClass: "el-icon-d-arrow-right" }),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("AddStudentUpdateAlbumDialog", {
        attrs: {
          kidsInSchool: _vm.kidsInSchool,
          getAppTypeUserLogin: _vm.getAppTypeUserLogin,
          isAddStudentUpdateAlbumDialog: _vm.isAddStudentUpdateAlbumDialog,
        },
        on: {
          closeDialog: _vm.closeAddStudentUpdateAlbumDialog,
          confirmData: _vm.handleConfirmKidsApply,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }